<template>
  <!--滑动banner -->
  <div  :class="['swiperbanner_container', { 'container-dark': theme_dark }]">
    <div class="gift-receiver ub ub-pc">
      <img :src="uinfo_to.photo" class="gift-photo" />
      <span class="gift-lable1">送给</span>
      <span class="gift-lable1">{{uinfo_to.nick.length > 6 ? uinfo_to.nick.substr(0,5) + '...' : uinfo_to.nick}}</span>
      <span class="gift-lable1 ub-f1 ub ub-ae ub-pe">金币余额:  {{coin_left}}</span>
    </div>

    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <li class="main-block ub ub-ver" v-for="(item, index) in gift_1" :key="index">
          <div class="gift-block ub">
            <li class="gift-item ub ub-pc ub-ver ub-f1" v-for="(sub_item,ii) in item" :key="sub_item.id" @click="tap_item(sub_item)">
              <div v-if="ii==0 && index==0 && is_festival==1" >
                <img :src="sub_item.url" class="gift-picture" />
                <div class="festival">{{festival_name}}</div>
              </div>
              <div v-if="!(ii==0 && index==0 && is_festival==1)">
                <img :src="sub_item.url" class="gift-picture" />
              </div>

              <div class="gift-name">{{sub_item.name}}</div>
              <div class="gift-coin">{{sub_item.coin}}金币</div>
            </li>
          </div>
        </li>
      </swiper-slide>

      <swiper-slide>
        <li class="main-block ub ub-ver" v-for="(item, index) in gift_2" :key="index">
          <div class="gift-block ub">
            <li class="gift-item  ub ub-pc ub-ver ub-f1" v-for="sub_item in item" :key="sub_item.id" @click="tap_item(sub_item)">
              <div>
                <img :src="sub_item.url" class="gift-picture" />
              </div>

              <div class="gift-name">{{sub_item.name}}</div>
              <div class="gift-coin">{{sub_item.coin}}金币</div>
            </li>
          </div>
        </li>
      </swiper-slide>

      <div class="swiper-pagination" slot="scrollbar"></div>
    </swiper>

    <alert ref="myConfirm" @userBehavior="userBehaviorFun"></alert>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
//import const_data from '../../api/const_data';
import Alert from "../../components/Alert.vue";
export default {
  name: "Swiper_Gift",
  components: {
    alert: Alert,
  },
  props: {
    toUid: String,
  },
  data() {
    return {
      gift_1: [],
      gift_2: [],

      uinfo_to: {
        uid: "",
        photo: "",
        nick: "",
        sex: "",
        age_range: "",
        loc_province: "",
      },

      coin_left: 0,

      swiperOption: {
        direction: "horizontal",

        observeParents: true, //观察父组件，当父组件变化时，自己随着变化
        observer: true, //观察自己，自己的参数变化时，更新
        centeredSlides: true, //设置为true时，活动块居中显示，默认下居左显示
        loop: false, //滑动过程中会在前后复制多个slider,效果看起来是循环的
        loopedSlides: 3, //设置滑动过程中所要用到的loop个数
        slidesPerView: "auto", //同时显示的slide数量
        loopAdditionalSlides: 100,
        autoPlay: {
          delay: 3000,
          disableOnInteraction: false, //鼠标移动上去时是否继续播放
        },
        pagination: { el: ".swiper-pagination" },
        paginationType: "bullets",
        paginationElement: "span",
      },

      is_festival: 0,
      festival_name: "",
      pre_send_time: new Date(),
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);

    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post", "delete", "put"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo", "act_sub_coin"]), //引入方法

    tap_item(item) {
      //console.log(JSON.stringify(item));
      //发送频率检查
      if (!this.check_sendRate()) {
        var bRtn = false;
        return bRtn;
      }

      //判断金币是否够支付
      var self = this;
      var uid = self.$store.state.uid;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          if (u.coin_left >= item.coin) {
            //增加后台验证,重新加载用户数据即可
            var send_data = {
              uid_from: uid,
              uid_to: self.uinfo_to.uid,
              amount: item.coin,
              score: item.score,
              type_dtl: "发送礼物",
              comment: item.name,
            };
            self.act_sub_coin({
              uid: uid,
              strSend: JSON.stringify(send_data),
              success: function (res) {
                if (res.state == "1") {
                  //扣金币成功
                  self.coin_left -= item.coin;

                  //可以发送，发送、并进行金币扣除
                  self.sendGift(item);
                } else {
                  //金币不足提示
                  self.$refs.myConfirm.show("金币余额不足,请先充值哦", {
                    type: "confirm",
                    confirmText: "充值",
                    titleText: "温馨提示",
                    data: "",
                  });
                  return false;
                }
              },
            });
          } else {
            //金币不足提示
            self.$refs.myConfirm.show("金币余额不足,请先充值哦", {
              type: "confirm",
              confirmText: "充值",
              titleText: "温馨提示",
              data: "",
            });
            return false;
          }
        },
      });
    },
    init_page() {
      var const_data = this.$store.state.const_data;
      this.gift_1 = tool.slice_arry(const_data.gift_1, 4);
      this.gift_2 = tool.slice_arry(const_data.gift_2, 4);

      var touid = this.toUid;
      var self = this;
      self.act_get_userinfo({
        uid: touid,
        success: function (u) {
          self.uinfo_to.uid = u.uid;
          self.uinfo_to.photo = u.photo;
          self.uinfo_to.nick = u.nick;
          self.uinfo_to.sex = u.sex;
          self.uinfo_to.age_range = u.age_range;
          self.uinfo_to.loc_province = u.loc_province;
        },
      });

      var uid = self.$store.state.uid;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          self.coin_left = u.coin_left;
        },
      });

      //加载dis信息
      var sysdic = this.$store.state.sysdic;

      if (sysdic) {
        this.is_festival = sysdic.is_festival;
        this.festival_name = sysdic.festival_name;
      }
    },

    sendGift(item) {
      var item = { type: "gift", name: item.name, url: item.url };
      this.$emit("send_gift", item);
    },

    userBehaviorFun(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mycoin" });
      }
    },

    check_sendRate() {
      var bRtn = true;

      var pre_send_time = this.pre_send_time;
      var dtm_now = new Date();
      var sp = dtm_now.getTime() - pre_send_time.getTime();

      if (sp < 300) {
        this.$toast.center("发送频率过高哦");
        bRtn = false;
        return bRtn;
      }
      this.pre_send_time = dtm_now;

      return bRtn;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-pagination {
  bottom: 2px !important;
}

.main-block {
  background-color: #333;
}

.gift-receiver {
  padding: 0.5rem 0.8rem;
  background: linear-gradient(86deg, rgba(162, 100, 231, .4), rgba(254, 156, 192, .4));
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  .gift-photo {
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 50%;
  }
  .gift-lable1 {
    font-size: 0.75rem;
    color: #333;
    margin-left: 0.5rem;
  }
}

.gift-block {
  padding: 0.2rem 0;
  justify-content: space-around;
  .gift-item {
    min-width: 5rem;
    .festival {
      position: fixed;
      top: 0.5rem;
      left: 0.3rem;
      color: #fff;
      border: 1px solid red;
      background-color: #f00;
      border-radius: 0.3rem;
      font-size: 0.5rem;
      padding: 0.2rem;
    }
    .gift-picture {
      height: 3.5rem;
      width: 3rem;
      padding: 0.1rem;
    }
    .gift-name {
      margin-top: 0.2rem;
      font-size: 0.8rem;
      color: #fff;
    }

    .gift-coin {
      font-size: 0.6rem;
      color: #959595;
      margin-top: 0.2rem;
    }
  }
}

.container-dark {
  .gift-receiver {
    .gift-lable1 {
      color: #fff;
    }
  }
}
</style>